import { BLUE_PLOOT, TEXT_BLACK_1 } from '@plootus/common';
import React, { useRef, useState } from 'react';
import { Box, Card, Typography, Grid, TextField, Button, Snackbar, Alert } from '@mui/material';
import { submitSupportContact } from './api';
import Accordion from '../../Utils/Accordion/Accordion';
import { faqs } from '../FAQs/Questions';
import styles from './faqs.module.css';

function Faqs() {
  const contactRef = useRef(null);
  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [query, setQuery] = useState('');
  const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

  const handleSubmitContact = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const { ok, status } = await submitSupportContact({ name, email, query });
      if (ok && status === 200) {
        setSnack({ open: true, msg: 'Your query is sent. Our support team will reach out to resolve your query.', severity: 'success' });
        setName('');
        setEmail('');
        setQuery('');
      } else {
        setSnack({ open: true, msg: 'Internal server error, please try later.', severity: 'error' });
      }
    } catch (err) {
      setSnack({ open: true, msg: 'Internal server error, please try later.', severity: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className={styles.main}>
        <div className={styles.textContent}>
          <h1 className={styles.philoH1}>Frequently Asked Questions</h1>
          <p className={styles.philoP}>
            Here are answers to some of the questions asked by our users.
          </p>
        </div>
      </div>
      <div className={styles.faqSection}>
        <div className={styles.faqLeft}>
          <div className={styles.faqLeftText}>
            <h2
              className={styles.faqHeader}
              style={{ fontSize: '25px', color: TEXT_BLACK_1 }}
            >
              Do you have any query regarding Plootus?
            </h2>
            <p
              className={styles.faqDesc}
              style={{ fontSize: '18px', color: TEXT_BLACK_1 }}
            >
              <span
                style={{ fontWeight: 700, color: BLUE_PLOOT, cursor: 'pointer' }}
                onClick={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })}
              >
                Contact us
              </span>{' '}
              anytime, and post your query below
            </p>
          </div>
        </div>
        <div className={styles.faqRight}>
          <div className={styles.AccordionContainer}>
            {faqs.map((faq, i) => {
              return (
                <Accordion
                  title={faq.title}
                  first={i === 0}
                  last={i === faqs.length - 1}
                  style={{ width: '90%' }}
                  contentStyle={{
                    padding: '20px',
                    fontSize: '18px',
                    backgroundColor: BLUE_PLOOT,
                  }}
                  index={i}
                >
                  <span className="accordion-text">{faq.content}</span>
                </Accordion>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.feedback} ref={contactRef}>
        <div className={styles.textContent} style={{ marginBottom: 16 }}>
          <h1 className={styles.philoH1}>Contact us</h1>
          <p className={styles.philoP}>
            Our team is here for you. We will get back to you in 2 business days.
          </p>
        </div>
        <Card className={styles.contactCard}>
          <Box component="form" onSubmit={handleSubmitContact}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography className={styles.label}>Full Name</Typography>
                <TextField
                  fullWidth
                  placeholder="Enter your full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={styles.input}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={styles.label}>Email Address</Typography>
                <TextField
                  fullWidth
                  type="email"
                  placeholder="Enter your Email Id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={styles.input}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={styles.label}>Your Query</Typography>
                <TextField
                  fullWidth
                  placeholder="Write your query here"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className={styles.input}
                  multiline
                  minRows={6}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <div className={styles.buttonDiv}>
                  <Button variant="contained" color="primary" type="submit" disabled={submitting}>Submit</Button>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Card>
        <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack({ ...snack, open: false })}>
          <Alert onClose={() => setSnack({ ...snack, open: false })} severity={snack.severity} sx={{ width: '100%' }}>
            {snack.msg}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default Faqs;
